<script lang="ts">
  import { Hospital } from '../lib/api';

  let pendientes = $state<any[]>([]);
  let error = $state<string | null>(null);
  let admPor = $state('');
  let motivoOm = $state('');

  async function cargar() {
    try { pendientes = await Hospital.kardexPendientes(); } catch (e:any) { error = e?.message; }
  }
  async function administrar(id: string) {
    if (!admPor) { error = 'Indica quién administra'; return; }
    try { await Hospital.administrar(id, admPor); await cargar(); } catch (e:any) { error = e?.message; }
  }
  async function omitir(id: string) {
    if (!motivoOm) { error = 'Indica motivo'; return; }
    try { await Hospital.omitir(id, motivoOm); await cargar(); }
    catch (e:any) { error = e?.message; }
  }
  $effect(() => { cargar(); });
</script>

<section>
  <header><h2>Kárdex de enfermería</h2><button onclick={cargar}>Recargar</button></header>
  {#if error}<p class="err">⚠ {error}</p>{/if}

  <div class="row">
    <label>Enfermera firma: <input bind:value={admPor} placeholder="Nombre / código"/></label>
    <label>Motivo omisión: <input bind:value={motivoOm} placeholder="Paciente NPO, etc."/></label>
  </div>

  <table>
    <thead><tr><th>Paciente</th><th>Medicamento</th><th>Dosis</th><th>Vía</th><th>Programada</th><th>Estado</th><th></th></tr></thead>
    <tbody>
      {#each pendientes as p (p.id)}
        <tr>
          <td>{p.pacienteId}</td>
          <td>{p.medicamentoNombre ?? p.medicamentoId}</td>
          <td>{p.dosis}</td>
          <td>{p.via ?? ''}</td>
          <td>{p.fechaProgramada}</td>
          <td>{p.estado}</td>
          <td>
            <button class="ok" onclick={() => administrar(p.id)}>Administrar</button>
            <button class="warn" onclick={() => omitir(p.id)}>Omitir</button>
          </td>
        </tr>
      {:else}<tr><td colspan="7" class="empty">Sin pendientes.</td></tr>{/each}
    </tbody>
  </table>
</section>

<style>
  header { display:flex; justify-content:space-between; align-items:center }
  header button { padding:.45rem .8rem; border:0; background:#0d6efd; color:#fff; border-radius:8px; cursor:pointer }
  .row { display:flex; gap:1rem; margin:1rem 0; flex-wrap:wrap }
  .row input { padding:.4rem; border:1px solid #ccc; border-radius:6px; margin-left:.4rem }
  table { width:100%; border-collapse:collapse }
  th, td { padding:.5rem .6rem; border-bottom:1px solid #eee; text-align:left; font-size:.9rem }
  .err { color:#b00020 } .empty { color:#888; text-align:center; font-style:italic }
  td button { padding:.25rem .6rem; border-radius:6px; border:0; color:#fff; cursor:pointer; margin-right:.3rem; font-size:.85rem }
  .ok { background:#1a9850 } .warn { background:#f9a825; color:#3a2a00 }
</style>
